// extracted by mini-css-extract-plugin
module.exports = {"btn":"_1bxDOyiivPbc5DphgQwk4x"};